// extracted by mini-css-extract-plugin
module.exports = {"root":"_9a09e114","dialogContent":"_aa7d0e6e"};